module.exports = __webpack_public_path__ + "img/76317.e00bb769.svg";